import React, { useState } from 'react';
import {  Form } from 'react-bootstrap';
import MaskedFormControl from 'react-bootstrap-maskedinput'

import './../CSS/form.css';

import moment from 'moment'

import axios from 'axios';
import Notification from './../../Components/assets/Modals/notification'
import {REGISTER_NURSE_STUDENT} from './../../url/index'
import NotifyError from './../../Components/assets/Modals/errorModal'

const Nursing = () => {
    
     const handleClear = () => {
      setEachEntry(initialInputState);
     }
    
     const prof_course_List = [
      {Id:0,Name:'Select'},
      {Id:1,Name:'GNM Nursing'},
      {Id:2,Name:'B.Sc Nursing'}
    ]
     
     const [validated, setValidated] = useState(false);
     const initialInputState = { 
       FirstName: "",
        MiddleName:"",
        LastName:"",
        PersonalEmail:"",
        PersonalCellNumber:'',
        ParentCellNumber:'',
        AdhaarNumber:'',
        PIN:'',
        DOB: '',
        dobError:'',
        Gender:'',
        IsAppearedJee:null,
        Category:'',
        Type:'',
        Address:'',
        FatherName:'',
         MotherName:'',
         Religion:'',
         BloodGroup:'',
         LastQualifyName:'',
         LastQualifyBoardName:'',
         LastQualifyRollNumber:'',
         LastQualifyMarks:'',
         ReferredBy:'',
         SchoolInfo:'',
         IsSuccess:false,
         message:'',
         isLoading:false,
         title:'',
         isHideErrorModal:true,
         errMessage:'',
         validationError:null,
         errortitle:'',
         typeError:'',
         categoryError:'',
         courseError:'',
         MR_Number:'',
         Amount:'',
        
        
         CourseId:0,
         msgList:[],
         appearedError: ''
      
      };
      const [eachEntry, setEachEntry] = useState(initialInputState);
      const {FirstName, LastName, MiddleName,
         PersonalEmail, PersonalCellNumber,ParentCellNumber,
         AdhaarNumber, PIN, DOB, dobError, Gender, Address,
         FatherName, MotherName,Religion,BloodGroup,
         LastQualifyName,LastQualifyBoardName, LastQualifyRollNumber, LastQualifyMarks,
         ReferredBy, SchoolInfo,IsSuccess, message, isLoading, title, isHideErrorModal, msgList,
          errMessage, validationError, errortitle, typeError, categoryError, IsAppearedJee, courseError,appearedError, MR_Number, Amount, CourseId} = eachEntry;
         
    const type2 = ''
          console.log("IsAppearedJee", IsAppearedJee)
      const handleInputChange = e => {
          setEachEntry({ ...eachEntry, [e.target.name]: e.target.value });
      };
    
      const handleNumberChange = e => {
          let num = e.target.value.replace(/\D/g, "");
          setEachEntry({ ...eachEntry, [e.target.name]: num });
      };
     
    const handleKeyDown = (e) =>{
      if (e.key === " ") {
        e.preventDefault();
      }
    }
    
    
    
    const handleDateChange = (e) =>{
    setEachEntry({ ...eachEntry, [e.target.name]: e.target.value, dobError: "" });
    }
    
    const dateValidation = () => {
    
    const dateArray = DOB.split("/");
    
    const day = parseInt(dateArray[0]); 
    const month = parseInt(dateArray[1]); 
    const year = parseInt(dateArray[2]); 
    const currentYear = new Date().getFullYear() 
    
    
    
    if(day > 31)
    {
      setEachEntry({ ...eachEntry, dobError: "Enter a valid day" });
      return false
    }
    else if(month > 12)
    {
      setEachEntry({ ...eachEntry, dobError: "Enter a valid month" });
      return false
    }
    else if(currentYear < year || (currentYear - year) < 12)
    {
      setEachEntry({ ...eachEntry, dobError: "Enter a valid year" });
      return false
    }
    
    else{
      var mydate = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]); 
    
      setEachEntry({ ...eachEntry, DOB: mydate, dobError: "" });
      return true;
    }
    
    }
    
    const handleRadioChange = (e) => {
      setEachEntry({ ...eachEntry, [e.target.name]: e.target.id });
    }

    const handleRadioJeeChange = (checked) => {
        
         setEachEntry({ ...eachEntry, IsAppearedJee: checked, appearedError:''});
       }
    
    const handleDDLChange = (e) =>{
      const {name,value,id} = e.target;
        setEachEntry({ ...eachEntry, [name]: value, [[id]]:'' });
      
    }
    
    const handleCourseDDLChange = (e) => {
      const {name,value,id} = e.target;
      setEachEntry({ ...eachEntry, [e.target.name]: value,  [[id]]:'' });
    }
    
    const handleMarkChange = (e) => {
      let num = e.target.value
      if(num.includes("."))
      {
        const dateArray = num.split(".");
        if(dateArray.length > 0)
        {
          
          const temp2 = parseInt(dateArray[1]);
          if(temp2 < 100) 
          setEachEntry({ ...eachEntry, [e.target.name]: num });
        }
       
      }
      else{
        if(num < 100)
        setEachEntry({ ...eachEntry, [e.target.name]: num });
      }
     
     
    }
    
    const handleSelectValidation = (e) => {
    const {Type, Category, Course} = eachEntry
    
    
      if(Category == null || Category.length == 0)
      {
        setEachEntry({ ...eachEntry, categoryError: "Select Category" });
        return  false
        }
     if(Type == null || Type.length == 0)
      {
      setEachEntry({ ...eachEntry, typeError: "Select Type" });
      return  false
      }
    
      if(CourseId == null || CourseId == 0)
      {
        setEachEntry({ ...eachEntry, courseError: "Select Course" });
      return  false
      }
    
     return true;
    
    }
    
   
    const  handleAppearError = () => {
      if(IsAppearedJee == null)
      {
        setEachEntry({ ...eachEntry, appearedError: 'Please Select an Option.' });
        return false;

      }
      else return true;
    }
     const handleSubmit = async (event) => {
      
       const form = event.currentTarget;
       event.preventDefault();
       event.stopPropagation();
       handleAppearError()
       if (form.checkValidity() === true && dateValidation() && handleSelectValidation() && handleAppearError()) {
        SaveStudent();
        }
        else{
          window.scrollTo(0, 0);
        }
         setValidated(true);
        
     };
    
     const SaveStudent = async () => {
      let response = null;
    var dob = moment.utc(eachEntry.DOB, "DD-MM-YYYY");
    
      try {
       // let formData = { ...eachEntry,DOB:dob, PIN: parseInt(eachEntry.PIN), LastQualifyMarks: parseFloat(eachEntry.LastQualifyMarks), Amount: parseInt(eachEntry.Amount)}
      let payload = {
        FirstName: eachEntry.FirstName,
        MiddleName:eachEntry.MiddleName,
        LastName:eachEntry.LastName,
        PersonalEmail:eachEntry.PersonalEmail,
        PersonalCellNumber:eachEntry.PersonalCellNumber,
        ParentCellNumber:eachEntry.ParentCellNumber,
        AdhaarNumber:eachEntry.AdhaarNumber,
        PIN: parseInt(eachEntry.PIN),
        DOB: dob,
        Gender:eachEntry.Gender,
       
        Category:eachEntry.Category,
        AccomodationType:eachEntry.Type,
        Address:eachEntry.Address,
        FatherName:eachEntry.FatherName,
         MotherName:eachEntry.MotherName,
         Religion:eachEntry.Religion,
         BloodGroup:eachEntry.BloodGroup,
         LastQualifyName:eachEntry.LastQualifyName,
         LastQualifyBoardName:eachEntry.LastQualifyBoardName,
         LastQualifyRollNumber:eachEntry.LastQualifyRollNumber,
         LastQualifyMarks: parseFloat(eachEntry.LastQualifyMarks),
         ReferredBy:eachEntry.ReferredBy,
         SchoolInfo:eachEntry.SchoolInfo,
         MR_Number:eachEntry.MR_Number,
         Amount: parseInt(eachEntry.Amount),
         CourseId:  parseInt(eachEntry.CourseId),
        IsAppearedJee:eachEntry.IsAppearedJee
         
      }
    
      console.log("payload", payload)
     setEachEntry({ ...eachEntry, isLoading: true});
     response = await axios.post(REGISTER_NURSE_STUDENT, payload);
    
     if(response.status === 201)
     {
      let course_name = ''
      
       if(payload.CourseId == 1){
        course_name = "GNM Nursing"
      }
    
      else if(payload.CourseId == 2){
        course_name = "B.Sc Nursing"
      }
    
       //let msg = "You have successfully registered for " + course_name + ". Your registration number is " + response.data.Payload + ". Thank you for showing interest for CTG."
       let temp = []
       temp.push("You have successfully registered for " + course_name)
       temp.push("Your registration number is " + response.data.Payload)
       temp.push("The final admission will take place after submitting the necessary documents and fee at Office")
    
       setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true, title:"Success", msgList: temp});
    }
    
    else{
      setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true, title:"Error occurred!", message:"Error Occurred...!"});
    
    }
    
      }
       catch (error) {
       
        if(error.response.data)
        {
           if(error.response.status === 400)
         {
            if(error.response.data.Error.ValidationErrors != null)
            {
              const validationError =  error.response.data.Error.ValidationErrors
              setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false, errortitle:"Validation Error occurred!", errMessage: error.response.data.Error.Message, validationError: validationError});
             // setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true,title:"Error occurred!", message: error.response.data.Error.Message});
            }
            else{
              setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: error.response.data.Error.Message });
            }
         
         }
         else{
          setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: "Please contact support." });
         }
        }
        else
        setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: "Please contact support." });
    }
    }
    //"The JSON value could not be converted to System.Nullable`1[System.Int64]. Path: $.AdhaarNumber | LineNumber: 0 | BytePositionInLine: 197."
    const handleClose = () => {
      setEachEntry({ ...eachEntry, IsSuccess: false, message : '', msgList : []});
      window.location.reload();
      window.scrollTo(0, 0);
      
    }
    const handleCloseErrorModal = () => {
      setEachEntry({ ...eachEntry, isHideErrorModal: true, message : '', msgList : [], errMessage : '',errortitle:'', validationError: null});
    }
    
      return (
        <div className='nurse'>
        <div className='container'>
      
          <div className='nurseheading'>
                   <label>CTG College of Nursing and Medical Science</label>
                   <br/>
                   <label>Registration cum Admission Form</label>
                    </div>
                    
                    
          <Form className='details' noValidate validated={validated} onSubmit={handleSubmit}>
           {/* <Container> 
          <Row className="mb-2"> */}
      <Form.Group   className="mb-2" controlId="validationCustom01">
        <Form.Label ><span className="required">First Name</span></Form.Label>
        <Form.Control 
        size='sm' 
        type="input" 
        placeholder="Enter first name" 
        required = {true}
        onChange={handleInputChange}
        value={FirstName}
        name="FirstName"
        onKeyDown={handleKeyDown}
        />
        <Form.Control.Feedback type="invalid">
                  Please enter  first name.
                </Form.Control.Feedback>
      </Form.Group>
    
      <Form.Group  className="mb-2" controlId="formBasicPassword">
        <Form.Label>Middle Name</Form.Label>
        <Form.Control
         size='sm'
          type="input"
           placeholder="Enter middle name"
           onChange={handleInputChange}
           value={MiddleName}
           name="MiddleName"
           onKeyDown={handleKeyDown}
           />
      </Form.Group>
    
      <Form.Group  className="mb-2" controlId="formBasicPassword">
        <Form.Label><span className="required">Last Name</span></Form.Label>
        <Form.Control 
        size='sm'
         type="input"
          placeholder="Enter last name"
           required
           onChange={handleInputChange}
           value={LastName}
           name="LastName"
           onKeyDown={handleKeyDown}
           />
        <Form.Control.Feedback type="invalid">
                  Please enter  last name.
                </Form.Control.Feedback>
      </Form.Group>
     
      <Form.Group   className="mb-2">
        <Form.Label><span className="required">Contact number</span></Form.Label>
        <Form.Control 
        size='sm' 
        type="tel"
        maxLength="10"
        minLength="10"
         pattern="[0-9]*"
          required
          onChange={handleNumberChange}
          value={PersonalCellNumber}
          name="PersonalCellNumber"
          />
        <Form.Control.Feedback type="invalid">
                  Please enter  contact number.
                </Form.Control.Feedback>
      </Form.Group>
      <Form.Group   className="mb-2" controlId="formBasicEmail">
        <Form.Label>Email</Form.Label>
        <Form.Control
         size='sm'
          type="email"
           placeholder="Enter email address"
           onChange={handleInputChange}
           value={PersonalEmail}
           name="PersonalEmail"
           />
        <Form.Control.Feedback type="invalid">
        Plesae enter valid email.
                </Form.Control.Feedback>
      </Form.Group>
      {/* </Row> */}
    
       {/* <Row className="mb-2"> */}
      <Form.Group  className="mb-2">
      
      <Form.Label><span className="required">Date Of Birth</span></Form.Label>
            <MaskedFormControl size='sm'
             type='text' 
              mask='11/11/1111'
              required
              onChange={handleDateChange}
              value = {DOB}
              name="DOB"
              />
            <Form.Control.Feedback type="invalid">
                  Please enter  DOB.
                </Form.Control.Feedback>
                <Form.Text style={{color:"red"}}>
                {dobError}
           </Form.Text>
          </Form.Group>
      
      <Form.Group className="mb-2">
      <Form.Label><span className="required">Gender</span></Form.Label>
      {['radio'].map((type) => (
        <div key={`inline-${type}`} className="mb-2">
          <Form.Check
          size='sm'
            inline
            label="Male"
            name="Gender"
            type={type}
            value = {Gender}
            onChange = {handleRadioChange}
            id= 'Male'
            required
          />
          <Form.Check
          size='sm'
            inline
            label="Female"
            name="Gender"
            type={type}
            value = {Gender}
            onChange = {handleRadioChange}
            id= 'Female'
            required
          />
           <Form.Check
            size='sm'
            inline
            label="Other"
            type={type}
             name="Gender"
             value = {Gender}
             onChange = {handleRadioChange}
             id= 'Other'
             required
          /> 
          
        </div>
        
      ))}
       <Form.Control.Feedback type="invalid">
         Please select  gender.
       </Form.Control.Feedback>
      </Form.Group>
     
      
        <Form.Group  className="mb-2">
      
      <Form.Label><span className="required">Select Course</span></Form.Label>
      <Form.Select size='sm' aria-label="Default select example" 
       name="CourseId"
       id = 'courseError'
       defaultValue={'DEFAULT'}
       onChange = {handleCourseDDLChange}
       value = {CourseId}
      required
      >
    
    {prof_course_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
    
    </Form.Select>
    <Form.Control.Feedback type="invalid">
                  Please select  Course.
                </Form.Control.Feedback>
                <Form.Text style={{color:"red"}}>
                {courseError}
           </Form.Text>
    </Form.Group>
      
     
   

      <Form.Group className="mb-2">
  <Form.Label>
    <span className="required">Have you appeared OJEE ?</span>
  </Form.Label>
  <div className="mb-2">
    <Form.Check
      size="sm"
      inline
      label="Yes"
      name="isAppearedJee"
      type="radio"
      value="true"
      checked={IsAppearedJee === true}
      onChange={() => handleRadioJeeChange(true)}
      id="ojje-yes"
     // isInvalid={form.checkValidity() && IsAppearedJee === null }
    />
    <Form.Check
      size="sm"
      inline
      label="No"
      name="isAppearedJee"
      type="radio"
      value="false"
      checked={IsAppearedJee === false}
      onChange={() => handleRadioJeeChange(false)}
      id="ojje-no"
     // isInvalid={ IsAppearedJee === null}
    />
  </div>
   
    <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
      {appearedError}
    </Form.Control.Feedback>
  
</Form.Group>

   
    
    <Form.Group  className="mb-2">
    <Form.Label><span className="required">Select Category</span></Form.Label>
    <Form.Select required size='sm' aria-label="Default select example"
     name="Category"
     id = 'categoryError'
     defaultValue={'DEFAULT'}
     onChange = {handleDDLChange}
     
    >
    <option value="DEFAULT" disabled>Select</option>
      <option value={"ST"}>ST</option>
      <option value={"SC"}>SC</option>
      <option value={"OBC"}>OBC</option>
      <option value={"SEBC"}>SEBC</option>
      <option value={"General"}>General</option>
    </Form.Select>
    <Form.Control.Feedback type="invalid">
         Please select  category.
       </Form.Control.Feedback>
       <Form.Text style={{color:"red"}}>
                {categoryError}
           </Form.Text>
    </Form.Group>
    
    <Form.Group required  className="mb-2">
      
      <Form.Label><span className="required">Select Type</span></Form.Label>
      <Form.Select required size='sm' aria-label="Default select example" 
       name="Type"
       id = 'typeError'
       defaultValue={'DEFAULT'}
       onChange = {handleDDLChange}
      >
      <option value="DEFAULT" disabled>Select</option>
       {/* <option value="" disabled selected>Select</option>  */}
      <option value= {"Day Boarding"}>Day Boarding</option>
      <option value= {"Day Scholar"}>Day Scholar</option>
      <option value={"Residential"}>Residential</option>
    </Form.Select>
    <Form.Control.Feedback type="invalid">
                  Please select  Type.
                </Form.Control.Feedback>
                 <Form.Text style={{color:"red"}}>
                {typeError}
           </Form.Text>
    </Form.Group>
    
    <Form.Group className="mb-2" controlId="formBasicPassword">
        <Form.Label>MR Number</Form.Label>
        <Form.Control size='sm'
         type="input" 
         placeholder="Enter money receipt no."
         
          value={MR_Number}
          name = "MR_Number"
          onChange={handleInputChange}
          />
        
      </Form.Group>
    
      <Form.Group  xs={2} className="mb-2" >
      <Form.Label>Amount Paid</Form.Label>
        <Form.Control  size='sm' 
       type="tel"
       maxLength="5"
       minLength="3"
        pattern="[0-9]*"
         onChange={handleNumberChange}
         value={Amount}
         name="Amount"
          />
        
      </Form.Group>
      
      {/* </Row>
      <Row className="mb-2"> */}
    <Form.Group className="mb-2" controlId="formBasicPassword" required>
        <Form.Label><span className="required">Father's Name</span></Form.Label>
        <Form.Control size='sm'
         type="input" 
         placeholder="Enter father name"
          required
          value={FatherName}
          name = "FatherName"
          onChange={handleInputChange}
          />
        <Form.Control.Feedback type="invalid">
         Please enter  father's name.
       </Form.Control.Feedback>
      </Form.Group>
    
      <Form.Group  className="mb-2" controlId="formBasicPassword" required>
        <Form.Label><span className="required">Mother's Name</span></Form.Label>
        <Form.Control size='sm'
         type="input" 
         placeholder="Enter mother name" 
         
         value={MotherName}
         name = "MotherName"
         onChange={handleInputChange}
         required/>
        <Form.Control.Feedback type="invalid">
         Please mother's  name.
       </Form.Control.Feedback>
      </Form.Group>
      <Form.Group  className="mb-2" required>
        <Form.Label><span className="required">Parent's Contact Number</span></Form.Label>
        <Form.Control size='sm'
          type="tel"
          maxLength="10"
          minLength="10"
           pattern="[0-9]*"
            required
            onChange={handleNumberChange}
            value={ParentCellNumber}
            name="ParentCellNumber"
         />
        <Form.Control.Feedback type="invalid">
         Please enter Parent's Contct no.
       </Form.Control.Feedback>
      </Form.Group>
      <Form.Group  className="mb-2" controlId="formBasicPassword" required>
      <Form.Label><span className="required">Religion</span></Form.Label>
        <Form.Control size='sm' 
        type="input"
         placeholder="Enter religion"
         value={Religion}
         name = "Religion"
         onChange={handleInputChange}
         required/>
        <Form.Control.Feedback type="invalid">
         Please enter religion.
       </Form.Control.Feedback>
      </Form.Group>
    
      <Form.Group  className="mb-2" >
        <Form.Label>Blood Group</Form.Label>
        <Form.Control size='sm' 
        type="input" 
        placeholder="Enter blood group" 
        value={BloodGroup}
         name = "BloodGroup"
         onChange={handleInputChange}
        />
      </Form.Group>
      {/* </Row>
      <Row className="mb-2"> */}
     <Form.Group   className="mb-2" controlId="formBasicPassword" required>
        <Form.Label><span className="required">Adhaar Number</span></Form.Label>
        <Form.Control size='sm' 
        type="tel"
        maxLength="12"
        minLength="12"
         pattern="[0-9]*"
          required
          onChange={handleNumberChange}
          value={AdhaarNumber}
          name="AdhaarNumber"
        />
        <Form.Control.Feedback type="invalid">
         Please enter adhhar no.
       </Form.Control.Feedback>
      
      </Form.Group>
    
      
    
      <Form.Group  className="mb-2" required>
        <Form.Label><span className="required">Last Qualification</span></Form.Label>
        <Form.Control size='sm'
         type="input"
          placeholder="Enter last qualification"
          value={LastQualifyName}
          name = "LastQualifyName"
          onChange={handleInputChange}
          required/>
        <Form.Control.Feedback type="invalid">
         Please enter Last Qualification.
       </Form.Control.Feedback>
      </Form.Group>
     
      <Form.Group  style = {{width:"280px"}} xs={3} className="mb-2" controlId="formBasicPassword" required>
        <Form.Label><span className="required">Last Qualification Board</span></Form.Label>
        <Form.Control   size='sm' 
        type="input"
         placeholder="Enter last qualification board" 
         value={LastQualifyBoardName}
          name = "LastQualifyBoardName"
          onChange={handleInputChange}
         required/>
        <Form.Control.Feedback type="invalid" >
         Please enter last qualification.
       </Form.Control.Feedback>
      </Form.Group>
     
      <Form.Group  className="mb-2" controlId="formBasicPassword" required>
        <Form.Label><span className="required">Roll number</span></Form.Label>
        <Form.Control size='sm'
         type="input" 
         placeholder="Enter roll number" 
         value={LastQualifyRollNumber}
         name = "LastQualifyRollNumber"
         onChange={handleInputChange}
         required/>
        <Form.Control.Feedback type="invalid">
         Please enter roll number.
       </Form.Control.Feedback>
      </Form.Group>
    
      <Form.Group  className="mb-2">
        <Form.Label>% of Marks</Form.Label>
        <Form.Control size='sm' 
        type="number" 
         className="w-50" 
         max={100}
         maxLength = {5}
         value={LastQualifyMarks}
         name = "LastQualifyMarks"
         onChange={handleMarkChange}
         />
      </Form.Group>
      <Form.Group  xs={2} className="mb-2" >
      
      <Form.Label><span className="required">PIN Code</span></Form.Label>
        <Form.Control  size='sm' className="w-50" 
       type="tel"
       maxLength="6"
       minLength="6"
        pattern="[0-9]*"
         required
         onChange={handleNumberChange}
         value={PIN}
         name="PIN"
          />
        <Form.Control.Feedback type="invalid">
         Please enter  PIN.
       </Form.Control.Feedback>
      </Form.Group>
      {/* </Row> */}
      
      <Form.Group  xs={3} className="mb-2" controlId="formControlsTextarea">
        <Form.Label><span className="required">Address</span></Form.Label>
        <textarea size='sm' className="form-control rounded-0"
         required id="exampleFormControlTextarea2" 
         rows="3" cols = '40'
         placeholder="Enter full address"
         value={Address}
         name = "Address"
         onChange={handleInputChange}
         ></textarea>
        <Form.Control.Feedback type="invalid">
         Please enter  address.
       </Form.Control.Feedback>
      </Form.Group>
      {/* <Row className="mb-2"> */}
      <Form.Group  className="mb-2" controlId="formControlsTextarea">
        <Form.Label>Referred by</Form.Label>
        <textarea size='sm' className="form-control rounded-0"
         id="exampleFormControlTextarea2" 
         rows="3" cols = '40' 
         placeholder="Referred by whom, address and contact number"
         value={ReferredBy}
         name = "ReferredBy"
         onChange={handleInputChange}
         ></textarea>
      </Form.Group>
      <Form.Group  className="mb-2" controlId="formControlsTextarea">
        <Form.Label>{"Last College Details"}</Form.Label>
        <textarea size='sm'
         className="form-control rounded-0" 
         id="exampleFormControlTextarea2" 
         rows="3" cols = '40' 
         placeholder= "Enter college details with address"
         value={SchoolInfo}
         name = "SchoolInfo"
         onChange={handleInputChange}
         ></textarea>
      </Form.Group>
     
     
      <div className="form-row" style={{width:'30%'}}>
      <div className="d-grid gap-2">
        <p></p>
        
      
      <button className="btn btn-primary" style={{background:'#055374'}} type="submit">
      <span className ="spinner-border spinner-border-sm" role="status" aria-hidden="true" hidden={!isLoading}></span>
        Register
        </button>
      
      <button className="btn btn-primary"style={{background:'red'}}  type="button" onClick={handleClear}>Clear</button>
    </div>
      {/* <div class="col">
      <Form.Group  className='Reg' controlId="formControlsTextarea">
      <Button variant='success' class="btn btn-primary"  type="submit">
      <span className ="spinner-border spinner-border-sm" role="status" aria-hidden="true" hidden={!isLoading}></span>
       Register
        
      </Button>
      </Form.Group>
      </div>
    
      <div class="col">
      <Form.Group className='Reg' controlId="formControlsTextarea">
      
      <Button   variant='danger' type="submit" onClick={navigateToHome}>
        Cancel
      </Button>
      </Form.Group>
      </div> */}
      
      </div>
    
      
    
     
      {/* </Container>  */}
    </Form>
    
    
    <Notification
    IsSuccess = {IsSuccess}
    handleClose = {handleClose}
    Message = {message}
    msgList = {msgList}
    title = {title}
    
    />
    
    {!isHideErrorModal && <NotifyError
    isHide = {isHideErrorModal}
     handleCloseErrorModal ={handleCloseErrorModal}
      title = {errortitle}
       message = {errMessage}
        Errors ={validationError}
    />} 
        </div>
        </div>
      )
}

export default Nursing